// =============================================================================
// FILE PATH: src/modules/pms/services/businessPartnerService.js
// =============================================================================

import axiosClient from "../../../api/axiosClient";

// =========================================================
// 🔥 GET ASSIGNABLE BUSINESS PARTNERS
// =========================================================
export const getAssignableBusinessPartners = () => {
  return axiosClient.get("/api/pms/assignable-business-partners");
};